import {FORM_ARRAY_BENEVA_ACCOUNTS} from '@/constants/engine';
import {ValueResolver} from '@/engine/types';
import {getBenevaAccounts, BenevaAccount} from './get-beneva-accounts';

/**
 * Retrieves Beneva Investment Accounts (CI)
 * @param valueResolver - The value resolver function
 * @returns Array of investment accounts
 */
export const getBenevaInvestmentAccounts = (valueResolver: ValueResolver): BenevaAccount[] => {
  return getBenevaAccounts(valueResolver, FORM_ARRAY_BENEVA_ACCOUNTS);
};
